<template>
    <div class="stretch-layout">
		<fetch-loader v-if="pending || error" :pending="pending" :error="error" @retry="refresh" class="stretch-layout"/>
		<template v-else>
			<h1 class="text-3xl sm:text-4xl md:text-6xl mb-20">{{ page.title }}</h1>

			<user-content :text="page.content" large class="flex-grow-1"/>

			<template v-if="indexStore.hasManagePermission">
				<divider/>
				<wrapper grow>
					<btn :to="$web('areas.sections.pages.edit', [$route.params.area, sectionStore.section._key, page._key])">
						<icon :icon="icons.edit"/>
						<span>Bearbeiten</span>
					</btn>
					<form-btn :action="`/v1/guide/${route.params.area}/sections/${sectionStore.section.id}/pages/${page.id}`"
							  color="error"
							  method="delete"
							  :confirm="{title: 'Seite löschen', message: 'Möchtest du diese Seite wirklich löschen?'}" @success="handleDestroyed">
						<icon :icon="icons.destroy"/>
						<span>Löschen</span>
					</form-btn>
				</wrapper>
			</template>
		</template>
    </div>
</template>

<script setup lang="ts">

import {useIndexStore} from "../../../../store";
import {useSectionStore} from "../../../../store/section";
import {editIcon, destroyIcon} from "@spoferan/nuxt-spoferan/icons";

const {$web} = useNuxtApp();
const router = useRouter();
const route = useRoute();
const params = route.params;
const indexStore = useIndexStore();
const sectionStore = useSectionStore();
const {value: cacheBusterValue} = useCacheBuster('page_ts');

const {reactiveData: page, pending, error, refresh} = await useApiFetch(`/v1/guide/${route.params.area}/sections/${route.params.section}/pages/${route.params.page}`, {
	auth: true, // We must authenticate to view unpublished pages
	params: {
		ts: cacheBusterValue
	}
});

watch(page, (newValue) => {
	if (newValue) {
		if (newValue._key !== params.page) {
			navigateTo({params: {page: newValue._key}}, {
				redirectCode: 308
			});
		}

		useMeta({
			title: `${newValue.title} - ${sectionStore.section.title}`,
			description: `Lese den Artikel "${newValue.title}" der Sektion "${sectionStore.section.title}" und erfahre alle Tipps und Tricks.`
		});
	}
}, {immediate: true});

const icons = {
	edit: editIcon,
	destroy: destroyIcon,
}

function handleDestroyed() {
	indexStore.removePageFromAreaSection(page.value);
	router.push($web('areas.show', params.area))
}

</script>
